export default __webpack_public_path__ + "static/partcloud-b16802f7247d9e1ccddd0ce0f291aff4.png";